module.exports = __webpack_public_path__ + "assets/img/more-btn-968c0662.png";